module.exports = __webpack_public_path__ + "f18c364973587ba7289a307f416b8da7.svg";